import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { spacing, colors } from '@chegg-ui/theme';
import { SecondaryLink } from '@chegg-ui/link';
import { Typography } from '@chegg-ui/typography';
import { getMediaQueryV2 } from '@chegg-me-lpc/utils';
import styled from 'styled-components';
export var FooterLegalContainer = styled.div.withConfig({
  componentId: "sc-j4ix62-0"
})(["display:flex;flex-direction:column-reverse;justify-content:space-between;align-items:center;margin:0 auto;", ""], getMediaQueryV2.lgAndHigher(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     flex-direction: inherit;\n     flex-wrap: wrap-reverse;\n  "]))));
export var LegalLinksContainer = styled.div.withConfig({
  componentId: "sc-j4ix62-1"
})(["display:flex;align-items:center;justify-content:center;flex-wrap:wrap;padding:", ";", " ", ""], spacing.px4, getMediaQueryV2.mdAndHigher(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n     padding: 0 ", ";\n  "])), spacing.px32), getMediaQueryV2.lgAndHigher(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n     padding: 0;\n     justify-content: flex-start;\n  "]))));
export var LegalLink = styled(SecondaryLink).withConfig({
  componentId: "sc-j4ix62-2"
})(["padding:", " ", ";span{color:", ";}"], spacing.px4, spacing.px12, colors.grey900);
export var FootNoteContainer = styled(Typography).withConfig({
  componentId: "sc-j4ix62-3"
})(["padding:", ";text-align:center;color:", ";"], spacing.px8, colors.grey700);
export var LegalText = styled(Typography).withConfig({
  componentId: "sc-j4ix62-4"
})(["padding:", ";color:", ";text-align:center;justify-content:center;", ""], spacing.px8, colors.grey700, getMediaQueryV2.lgAndHigher(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n     max-width: 400px;\n     text-align: start;\n  "]))));